import React from 'react';
import { useRouter } from 'next/router';

export const PreviewPageIndicator = () => {
  const router = useRouter();
  const { query, pathname } = router;
  const isPreview = typeof query.preview !== 'undefined';

  const handleRemovePreview = async () => {
    // Clonamos el query para eliminar el parámetro preview
    const newQuery = { ...query };
    delete newQuery.preview;
    // Actualizamos la URL sin el parámetro preview y recargamos la página
    await router.push({
      pathname,
      query: newQuery,
    });
    router.reload();
  };

  if (!isPreview) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="flex items-center rounded-full bg-primaryDark/90 px-4 py-2 text-white shadow-lg">
        <span className="mr-2 cursor-default">Página de prueba</span>
        <button onClick={handleRemovePreview} aria-label="Cerrar preview">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 cursor-pointer"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 011.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
